import carouselExtSlidesCtrl from './carouselExtSlides.ctrl.js';

export const carouselExtSlidesComponent = {
    controller: carouselExtSlidesCtrl,
    bindings: {
        generationChildren: '<?',
    },
};
